import PropTypes from "prop-types"

const SOLUTION = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
})

const SIGMA_SOLUTION = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  alias: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  workbookId: PropTypes.string.isRequired,
  workbookUrlId: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
})

const SOLUTIONS = PropTypes.arrayOf(SOLUTION)
const SIGMA_SOLUTIONS = PropTypes.arrayOf(SIGMA_SOLUTION)

export {
  SOLUTION,
  SOLUTIONS,
  SIGMA_SOLUTION,
  SIGMA_SOLUTIONS,
}
